export default "__VITE_ASSET__C4xlyrQY__"